import { render, staticRenderFns } from "./VCheckBox.vue?vue&type=template&id=e5332bee&scoped=true"
import script from "./VCheckBox.ts?vue&type=script&lang=ts&external"
export * from "./VCheckBox.ts?vue&type=script&lang=ts&external"
import style0 from "./VCheckBox.vue?vue&type=style&index=0&id=e5332bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5332bee",
  null
  
)

export default component.exports